import { render } from "./smartro_pay_fail.vue?vue&type=template&id=ea9b4e40&scoped=true"
import script from "./smartro_pay_fail.vue?vue&type=script&lang=js"
export * from "./smartro_pay_fail.vue?vue&type=script&lang=js"

import "./smartro_pay_fail.vue?vue&type=style&index=0&id=ea9b4e40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea9b4e40"]])

export default __exports__